var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient0, _linearGradient1, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAv1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    enableBackground: "new 0 0 128 128",
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9ddd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5137,
    stopColor: "#f8dbce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8222,
    stopColor: "#f6d3c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4cabd"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 30,
    x2: 42,
    xlinkHref: "#lg1",
    y1: 46,
    y2: 46
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 98,
    x2: 86,
    xlinkHref: "#lg1",
    y1: 46,
    y2: 46
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d0bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1beae"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(.964 -.266 .266 .964 -44.863 -244.768)",
    gradientUnits: "userSpaceOnUse",
    x1: -0.999,
    x2: 5.88,
    xlinkHref: "#lg2",
    y1: 302.335,
    y2: 302.335
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(-.964 -.266 -.266 .964 -1701.138 -244.768)",
    gradientUnits: "userSpaceOnUse",
    x1: -1807.332,
    x2: -1800.453,
    xlinkHref: "#lg2",
    y1: -196.701,
    y2: -196.701
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.75,
    x2: 74.25,
    xlinkHref: "#lg1",
    y1: 69.25,
    y2: 89.75
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.671,
    x2: 78.098,
    y1: 65.66,
    y2: 85.455
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eeae9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3161,
    stopColor: "#efb4a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7381,
    stopColor: "#f4c3b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d0bf"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.638,
    x2: 86.363,
    xlinkHref: "#lg1",
    y1: 19.638,
    y2: 64.363
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 64,
    x2: 64,
    y1: 126,
    y2: 86
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0e3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfe6ff"
  }))), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 64,
    x2: 64,
    y1: 44,
    y2: 58
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d0bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeae9a"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 64,
    x2: 64,
    y1: 99.261,
    y2: 131.999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e15c63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4062,
    stopColor: "#de585f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8264,
    stopColor: "#d44b53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ce444c"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 64,
    x2: 64,
    y1: 98.457,
    y2: 89.331
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e15c63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e15c63"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7f4ff"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 54,
    x2: 54,
    xlinkHref: "#lg3",
    y1: 77.735,
    y2: 104.211
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 74,
    x2: 74,
    xlinkHref: "#lg3",
    y1: 72.572,
    y2: 100.931
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#198dc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12639b"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 37,
    x2: 37,
    xlinkHref: "#lg4",
    y1: 86.666,
    y2: 126
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3779a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174f71"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.5,
    x2: 46.5,
    xlinkHref: "#lg5",
    y1: 86.666,
    y2: 126
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 91,
    x2: 91,
    xlinkHref: "#lg4",
    y1: 86.666,
    y2: 126
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(-1 0 0 1 296 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 214.5,
    x2: 214.5,
    xlinkHref: "#lg5",
    y1: 86.666,
    y2: 126
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d766a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53371a"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.708,
    x2: 42.971,
    xlinkHref: "#lg6",
    y1: 27.371,
    y2: 32.487
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.627,
    x2: 92.911,
    y1: 21.701,
    y2: 37.869
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5f4534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53371a"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.87,
    x2: 79.806,
    xlinkHref: "#lg6",
    y1: 4.75,
    y2: 30.436
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m41.546 44.443c1.262 4.333-.199 8.543-3.262 9.402-3.063.86-6.569-1.956-7.831-6.289s.199-8.543 3.262-9.402c3.064-.859 6.57 1.956 7.831 6.289z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m86.454 44.443c-1.262 4.333.199 8.543 3.262 9.402 3.063.86 6.569-1.956 7.831-6.289s-.199-8.543-3.262-9.402c-3.064-.859-6.57 1.956-7.831 6.289z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m41.321 45.105c.609 2.153-.383 4.298-2.217 4.793-1.834.494-3.815-.85-4.424-3.002-.609-2.153.383-4.298 2.217-4.793s3.814.849 4.424 3.002z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m86.679 45.105c-.609 2.153.383 4.298 2.217 4.793 1.834.494 3.815-.85 4.424-3.002.609-2.153-.383-4.298-2.217-4.793s-3.814.849-4.424 3.002z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m75 89h-22l1-20h20z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m74 69h-20l-.244 4.882 15.118 15.118h6.126z",
    fill: "url(#SVGID_6_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m64 76c-14.3 0-26-11.7-26-26v-16c0-14.3 11.7-26 26-26 14.3 0 26 11.7 26 26v16c0 14.3-11.7 26-26 26z",
    fill: "url(#SVGID_7_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m77.889 86h-27.778c-18.761 0-34.111 15.3-34.111 34v6h96v-6c0-18.7-15.35-34-34.111-34z",
    fill: "url(#SVGID_8_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m54.263 46h-.527c-.955 0-1.736-.781-1.736-1.737v-2.527c0-.955.781-1.736 1.737-1.736h.527c.955 0 1.736.781 1.736 1.737v2.527c0 .955-.781 1.736-1.737 1.736z",
    fill: "#51251f"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m74.263 46h-.527c-.955 0-1.736-.781-1.736-1.737v-2.527c0-.955.781-1.736 1.737-1.736h.527c.955 0 1.736.781 1.736 1.737v2.527c0 .955-.781 1.736-1.737 1.736z",
    fill: "#51251f"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m64.158 58h-.316c-1.563 0-2.842-1.279-2.842-2.842v-8.316c0-1.563 1.279-2.842 2.842-2.842h.316c1.563 0 2.842 1.279 2.842 2.842v8.316c0 1.563-1.279 2.842-2.842 2.842z",
    fill: "url(#SVGID_9_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m57.001 37.895c-.049 0-.099-.003-.149-.011l-6-.895c-.546-.082-.923-.59-.842-1.137.082-.546.594-.923 1.137-.842l6 .895c.546.082.923.59.842 1.137-.074.496-.501.853-.988.853z",
    fill: "#7a5954"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m70.999 37.895c-.487 0-.914-.356-.988-.853-.081-.546.295-1.055.842-1.137l6-.895c.542-.083 1.055.295 1.137.842.081.546-.295 1.055-.842 1.137l-6 .895c-.05.007-.1.011-.149.011z",
    fill: "#7a5954"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m62.029 64.247c-2.517 0-4.607-.162-5.113-.205-.55-.046-.958-.53-.913-1.081.046-.55.52-.962 1.081-.913 4.421.372 12.091.348 13.855-1.296.403-.376 1.037-.354 1.413.05s.354 1.037-.05 1.413c-1.788 1.669-6.508 2.032-10.273 2.032z",
    fill: "#f09890"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m67 99.045h-6l-2 26.955h10z",
    fill: "url(#SVGID_10_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m66 89h-4s-4.012 5.976-4 6l3 4.045h6l3-4.045c-.022-.076-4-6-4-6z",
    fill: "url(#SVGID_11_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m53 79 11 7-10 15-10-15z",
    fill: "url(#SVGID_12_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m75 79-11 7 10 15 10-15z",
    fill: "url(#SVGID_13_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m16 120v6h42l-14.583-39.334c-15.584 3.123-27.417 16.916-27.417 33.334z",
    fill: "url(#SVGID_14_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m43.417 86.666c-2.299.461-4.513 1.159-6.622 2.058l-1.795 19.276 8 7-7 5 6 6h16z",
    fill: "url(#SVGID_15_)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m112 120v6h-42l14.583-39.334c15.584 3.123 27.417 16.916 27.417 33.334z",
    fill: "url(#SVGID_16_)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m84.583 86.666c2.299.461 4.513 1.159 6.622 2.058l1.795 19.276-8 7 7 5-6 6h-16z",
    fill: "url(#SVGID_17_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m31 20s3.903 5.164 7.009 19c0 0 4.512-8.735 9.991-13 0 0-4.276-.98-17-6z",
    fill: "url(#SVGID_18_)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m88 18s5.105 7.164 2 21c0 0-5.521-9.735-11-14 0 0 7.398-1.885 9-7z",
    fill: "url(#SVGID_19_)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m88 18c0-5.744-4.499-14-21-14-22.758 0-23.805 10.831-36 16 0 0 11.181 8 27 8 23.758 0 30-6.788 30-10z",
    fill: "url(#SVGID_20_)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAv1);
export default __webpack_public_path__ + "static/media/av1.ff8aef256142e3a2c1865ec4a3a117af.svg";
export { ForwardRef as ReactComponent };